import { CustomState } from "@bevco/Store/Reducers";
import { searchFilteringStateValues } from "@bevco/Utilities/Utilities";
import SearchFilteringSelector from "@bevco/Widgets/ProductList/SearchFilteringSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const { loaded, brandFacets, productLineFacets, categoryFacets, attributeTypeFacets } = searchFilteringStateValues(
        state,
        true,
    );

    return {
        loaded,
        brandFacets,
        productLineFacets,
        categoryFacets,
        attributeTypeFacets,
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SearchFilteringFiltersStyles {
    wrapper?: InjectableCss;
}

export const searchFilteringFiltersStyles: SearchFilteringFiltersStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: 16px;
            overflow-x: auto;
            white-space: nowrap;
        `,
    },
};

const styles = searchFilteringFiltersStyles;

const SearchFilteringFilters = ({
    loaded,
    brandFacets,
    productLineFacets,
    categoryFacets,
    attributeTypeFacets,
    addProductFilters,
    removeProductFilters,
}: Props) => {
    if (!loaded) {
        return null;
    }

    const onChangeBrandHandler = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ brandIds: [facet.id] });
        } else {
            addProductFilters({ brandIds: [facet.id] });
        }
    };

    const onChangeProductLineHandler = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ productLineIds: [facet.id] });
        } else {
            addProductFilters({ productLineIds: [facet.id] });
        }
    };

    const onChangeCategoryHandler = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ categoryId: facet.id });
        } else {
            addProductFilters({ categoryId: facet.id });
        }
    };

    const onChangeAttributeValueHandler = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ attributeValueIds: [facet.id] });
        } else {
            addProductFilters({ attributeValueIds: [facet.id] });
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>

            {productLineFacets.length > 0 && (
                <SearchFilteringSelector
                    id="product-lines"
                    label={translate("Product Lines")}
                    facetOptions={productLineFacets}
                    onChangeFacet={onChangeProductLineHandler}
                ></SearchFilteringSelector>
            )}

            {categoryFacets.length > 0 && (
                <SearchFilteringSelector
                    id="categories"
                    label={translate("Categories")}
                    facetOptions={categoryFacets}
                    onChangeFacet={onChangeCategoryHandler}
                ></SearchFilteringSelector>
            )}

            {attributeTypeFacets.map(groupFacet => (
                <SearchFilteringSelector
                    key={`attributesFacet_${groupFacet.id}`}
                    id={`attributes_${groupFacet.id}`}
                    label={translate(groupFacet.name)}
                    facetOptions={groupFacet.items}
                    onChangeFacet={onChangeAttributeValueHandler}
                ></SearchFilteringSelector>
            ))}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilteringFilters as any) as any;
